import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { SEARCH_ICON, X_ICON } from 'src/app/utils/svgIcons';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PermisosAutomatizadosService } from 'src/app/services/permisos-automatizados.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { getS3File, upload } from 'src/app/utils/s3';
import * as FileSaver from 'file-saver';
import { FILE_EXTENSION, LAYOUTS, decrypt, encrypt } from 'src/app/utils/constants';
import * as XLSX from 'xlsx';
import { s3 } from "@sistemas-upax/utils";

@Component({
  selector: 'app-asignacion-funciones',
  templateUrl: './asignacion-funciones.component.html',
  styleUrls: ['./asignacion-funciones.component.scss']
})

export class AsignacionFuncionesComponent implements OnInit {
  @Input() profileName: any;
  @Input() userPermissions: any;
  @Input() profileUpdateInfo: any;
  @Input() urlExcel: string;
  @Output() segmentationBySapFunctions = new EventEmitter<boolean>();;
  @Output() selectedItemsList = new EventEmitter<any>();
  @Output() employeesArrayList = new EventEmitter<any>();
  @Output() jsonDataKey = new EventEmitter<string>();
  @ViewChild('fileX3') fileX3: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;

  functionsForm: FormGroup;
  userData = JSON.parse(localStorage.getItem("usuario"));
  selectedFunctions = [];
  checkedIDs: any = [];
  functionsList: any = [];
  searchText: any;
  searchEmployee: any;
  editingProfile: boolean = false;
  nameFile: string = 'Layout.xmls'
  onValidateEmployees: boolean = false;
  arrayBuffer: any = [];
  jsonData : any = [];
  allowedEmployees : any = [];
  fileName: string = null
  showSapFunction: boolean = true
  onActiveTab: boolean = true
  totalNumberFunctions: number = 0
  totalNumberExcel: number = 0
  showAllowedEmployees: boolean = true
  notAllowedEmployees: any = []

  constructor(
    private permisosAutomatizados: PermisosAutomatizadosService,
    private ngxService: NgxUiLoaderService,
    sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry, ){
      iconRegistry.addSvgIconLiteral('icon-search', sanitizer.bypassSecurityTrustHtml(SEARCH_ICON));
      iconRegistry.addSvgIconLiteral('icon-x', sanitizer.bypassSecurityTrustHtml(X_ICON));
    }

  ngOnInit(): void {
    this.fetchSelectedItems()
    this.fetchCheckedIDs()
    this.getFunctions();
    this.functionsForm = new FormGroup({
      'name': new FormControl('Directivos', [Validators.required, Validators.minLength(3), Validators.maxLength(200)]),
    }); 
  }

  async getFunctions() {
    this.ngxService.start();
    try {
      let permissions: any = this.userPermissions
      console.log('EXCEL PERMISOS', this.urlExcel)

      //EXCEL DATA
      if( this.urlExcel != null ) {
        const responseV2 = await fetch(
          `https://s3.amazonaws.com/${environment.AWS_CONFIG.bucketTasks}/${this.urlExcel}`, {
          cache: "no-store" 
        });
        const employeeData = await responseV2.json();
        /* const jsonEmployees: any = await s3.download(
          environment.env, 
          environment.AWS_CONFIG.bucketTasks, 
          this.urlExcel, 
          ); 
          let stringData = new TextDecoder().decode(jsonEmployees.Body);
          let employeeData = JSON.parse(stringData) 
          */
        this.onActiveTab = false
        let dataExcel = await this.getSegmentationByExcel(employeeData.empleados)
        const dataFiltered: any = await this.filterByEmployeeNumber(dataExcel)
        this.employeesArrayList.emit(dataFiltered)

        this.showSapFunction = false
        this.onValidateEmployees = true
        this.fileName = 'Carga_empleados.xlsm'
      }

      const result: any = await this.permisosAutomatizados.getFunctions(this.userData.idCliente);
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data
      
      if( response.code === 200 ) {
        if(decoded.data.items[0]) {
          this.functionsList = decoded.data.items[0].funciones;
          const funciones = permissions.functions
          this.totalNumberFunctions = 0

          //FUNCTIONS
          if( funciones[0] ) { //IF IS EDITING PROFILE
            this.editingProfile = true;
    
            funciones.forEach(funct => {
              this.functionsList.forEach( y => {
                if ( funct == y.idFuncion ) {
                  this.totalNumberFunctions = this.totalNumberFunctions + y.total
                }
              });
            });
            this.selectedItemsList.emit(permissions.functions)
          }
        }
        else {
          this.ngxService.stop();
          return this.showAlert('Información', `No se encontraron módulos disponibles para mostrar.`)
        }
        //SI SE ESTA EDITANDO
        if(this.editingProfile){
          this.restoreFunctionsValues()
        }
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      }
      this.ngxService.stop();

    } catch(err) {
      console.log(err);
      this.ngxService.stop();
      return this.showAlert('Error al crear perfil', `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`)
    }
  }

  cleanDuplicateData(data: any[]) {
    const idsUnicos = [...new Set(data.map(item => item.NO_EMPLEADO))];

    return idsUnicos.map(id => ({
      NO_EMPLEADO: id
    }));
  }

  async getSegmentationByExcel(arrayEmployees: any) {
    try {
      let arreglo: any = []

      for (const value of arrayEmployees) {
        arreglo.push({NO_EMPLEADO: value })
      }
      
      let response: any = await this.uploadFile(arreglo)
      this.jsonDataKey.emit(response.key)
      let keyRoute: any = await this.validateEmployees(response.key)
      const jsonData: any = await getS3File(environment.AWS_CONFIG.validatorBucket, keyRoute);
      let stringData = new TextDecoder().decode(jsonData.Body);
      let employeeData = JSON.parse(stringData)
      let listArray = []

      employeeData.allowed.forEach(person => {
        listArray.push({
          employee_name: person.employee_name,
          employee_number: person.employee_number,
          employee_data: `${person.employee_number} - ${person.employee_name}`
        })
      });
      this.allowedEmployees = listArray
      this.notAllowedEmployees = employeeData.notAllowed
      this.totalNumberExcel = employeeData.allowed.length

      return employeeData.allowed;
    
    } catch (error) {
      console.log('Error al obtener datos de audiencia', error)
    }
  }

  restoreFunctionsValues() {
    for (let i = 0; i < this.userPermissions.functions.length; i++) {
      this.functionsList.forEach(element => {
        //BUSQUEDA POR ID
        if(element.idFuncion == this.userPermissions.functions[i]){
          //ACTUALIZA PROPIEDAD IsSelected A TRUE
          element.isSelected = true;
        }
      });
    }
  }

  showAlert(title:string ,message:string){
    Swal.fire({
      title: title,
      icon:  'info',
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  fetchSelectedItems() {
    this.totalNumberFunctions = 0
    this.selectedFunctions = this.functionsList.filter((value, index) => {
      return value.isSelected
    });
    this.selectedFunctions.forEach(funcion => {
      this.totalNumberFunctions = this.totalNumberFunctions + funcion.total
    });
    this.selectedItemsList.emit(this.selectedFunctions)
  }

  fetchCheckedIDs() {
    this.checkedIDs = []
    this.functionsList.forEach((value, index) => {
      if (value.completed) {
        this.checkedIDs.push(value.position);
      }
    });
  }

  async downloadFile( type: String ) {
    try {
      this.ngxService.start();
      let layout: string = null
      let templateName: string = null

      if ( type == 'excel') {
        layout = LAYOUTS.EMPLOYEES_EXCEL
        templateName = 'Formato_empledos'
      }
      if ( type == 'excel_x3') {
        layout = LAYOUTS.EXCEL_X3
        templateName = 'Formato_X3'
      }
      if ( type == 'funciones') {
        layout = LAYOUTS.FUNCTIONS_LAYOUT
        templateName = 'Formato_funciones'
      }

      const file = await getS3File(environment.AWS_CONFIG.credentials.structureBucket, layout);
      this.saveAsExcelFile(file.Body, templateName, type);

    } catch (err) {
      this.ngxService.stop();
      return this.showAlert('Error en descarga', `Lo sentimos, hubo un problema en la descarga del archivo, favor de volver a intentar.`)
    }
  }

  saveAsExcelFile(buffer: any, name: string, type: String): void {
    try {
      const data: Blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      type == 'excel_x3' || type == 'funciones' ? FileSaver.saveAs(data, name + '.xlsx')
      : FileSaver.saveAs(data, name + '.xlsm')
      this.ngxService.stop();

    } catch (e) {
      console.log(e);
    }
  }

  async uploadExcel($event: any, fileType: string) {
    $event.preventDefault();
    const files = $event.dataTransfer ? $event.dataTransfer.files : $event.target.files;
    let file_name : string = ""

    for (let i = 0; i < files.length; i++) {
      file_name = files[i].name.split(/\.(?=[^\.]+$)/);
      const type = this.validateExtension(file_name[1]);

      if (type !== 'application/vnd.ms-excel') {
        let msgError = ''

        if( fileType === 'excel_x3' || fileType === 'funciones' ) {
          msgError = `Solo se permiten archivos formato Excel (.XLSX)`;
        }
        if( fileType === 'excel' ) {
          msgError = `Solo se permiten archivos formato Excel (.XLSM)`;
        }

        return this.showAlert('Error al subir el archivo', msgError);
      }

      if (type) {
        if ((files[i].size * 0.000001) < 15) {
          if( fileType === 'excel_x3' ) {
            this.readExcelX3(files[0])
          }
          if( fileType === 'excel' ) {
            this.readExcel(files[0])
          }
          if( fileType === 'funciones' ) {
            this.readExcelFunctions(files[0])
          }

        } else {
          const msg = `La longitud del archivo ${files[i].name} excede los límites permitidos. (15 MB)`;
          return this.showAlert('Error al subir el archivo', msg);
        }
      }
    }
  }

  readExcel(file: any) {
    try {
      this.ngxService.start();

      setTimeout(async ()=> {
        const readFilePromise = new Promise((resolve,reject)=>{
          const fileReader = new FileReader();
          fileReader.onload = e => {
            this.arrayBuffer = fileReader.result;
            const data = new Uint8Array(this.arrayBuffer);
            const arr = new Array();
            for (let i = 0; i !== data.length; i++){
              arr[i] = String.fromCharCode(data[i]);
            }
            const bstr = arr.join('');
            const workbook = XLSX.read(bstr,{type:'binary'});
            const first_sheet_name = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[first_sheet_name];

            resolve(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
          };
          this.fileName = file.name;
          fileReader.readAsArrayBuffer(file);
        });
        this.jsonData = await readFilePromise;
        this.jsonData = this.cleanDuplicateData(this.jsonData);
        console.log("Data sin duplicados:", this.jsonData.length);
        let response: any = await this.uploadFile(this.jsonData)
        this.jsonDataKey.emit(response.key)
        let keyRoute: any = await this.validateEmployees(response.key)
        //let url: string = `ru-inasistencias/${keyRoute}`
        //const jsonData: any = await getS3File(environment.AWS_CONFIG.bucket, url);
        const jsonData: any = await getS3File(environment.AWS_CONFIG.validatorBucket, keyRoute);
        let stringData = new TextDecoder().decode(jsonData.Body);
        let employeeData = JSON.parse(stringData) 
        let listArray = []

        employeeData.allowed.forEach(person => {
          listArray.push({
            employee_name: person.employee_name,
            employee_number: person.employee_number,
            employee_data: `${person.employee_number} - ${person.employee_name}`
          })
        });
        this.allowedEmployees = listArray
        this.notAllowedEmployees = employeeData.notAllowed
        this.totalNumberExcel = employeeData.allowed.length
        
        const dataEmployees: any = await this.filterByEmployeeNumber(employeeData.allowed)
        this.employeesArrayList.emit(dataEmployees)

        if (employeeData.allowed.length === 0 ){
          this.cleanFile()
          this.ngxService.stop()
          return this.showAlert('Aviso', `No se encontraron registros validos.`)
        }
        else {
          this.onValidateEmployees = true
        }

        this.ngxService.stop() 

      },500)

    } catch (error) {
      console.log(error);
      this.ngxService.stop()
      return this.showAlert('Error al subir el archivo', `Lo sentimos, hubo un problema al subir archivo, favor de volver a intentar.`)
    }
  }

  readExcelFunctions(file: any) {
    try {
      this.ngxService.start();

      setTimeout(async ()=> {
        const readFilePromise = new Promise((resolve,reject)=>{
          const fileReader = new FileReader();
          fileReader.onload = e => {
            this.arrayBuffer = fileReader.result;
            const data = new Uint8Array(this.arrayBuffer);
            const arr = new Array();
            for (let i = 0; i !== data.length; i++){
              arr[i] = String.fromCharCode(data[i]);
            }
            const bstr = arr.join('');
            const workbook = XLSX.read(bstr,{type:'binary'});
            const first_sheet_name = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[first_sheet_name];

            resolve(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
          };
          this.fileName = file.name;
          fileReader.readAsArrayBuffer(file);
        });
        this.jsonData = await readFilePromise;
        let auxArray = []

        if(this.userPermissions.functions.length > 0){
          this.userPermissions.functions.forEach( func => { 
            auxArray.push(func)
          })
        }

        this.jsonData.forEach( func => {
          const validation = auxArray.includes(func['ID FUNCION'])
          
          if( !validation ) {
            this.functionsList.map(element => {
              //BUSQUEDA POR ID
              if(element.idFuncion == func['ID FUNCION']) {
                //ACTUALIZA PROPIEDAD IsSelected A TRUE
                element.isSelected = true;
                this.totalNumberFunctions = this.totalNumberFunctions + element.total
              }
            });
          }
        })
        this.selectedItemsList.emit(this.functionsList)
        this.ngxService.stop() 

      },500)

    } catch (error) {
      console.log(error);
      this.ngxService.stop()
      return this.showAlert('Error al subir el archivo', `Lo sentimos, hubo un problema al subir archivo, favor de volver a intentar.`)
    }
  }

  readExcelX3(file: any) {
    try {
      this.ngxService.start();

      setTimeout(async ()=> {
        const readFilePromise = new Promise((resolve,reject)=>{
          const fileReader = new FileReader();
          fileReader.onload = e => {
            this.arrayBuffer = fileReader.result;
            const data = new Uint8Array(this.arrayBuffer);
            const arr = new Array();
            for (let i = 0; i !== data.length; i++){
              arr[i] = String.fromCharCode(data[i]);
            }
            const bstr = arr.join('');
            const workbook = XLSX.read(bstr,{type:'binary'});
            const first_sheet_name = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[first_sheet_name];

            resolve(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
          };
          this.fileName = file.name;
          fileReader.readAsArrayBuffer(file);
        });
        this.jsonData = await readFilePromise;
        let numeroEmpleado =[],puntoDeVenta =[],idFuncion = [];
        for (let index = 0; index < this.jsonData.length; index++) {
          const element = this.jsonData[index];
          if(element['No_Empleado'])numeroEmpleado.push(element['No_Empleado'])
          if(element['Punto_Venta'])puntoDeVenta.push(element['Punto_Venta'])
          if(element['id_funcion'])idFuncion.push(element['id_funcion'])
        }
        console.log("empleados", numeroEmpleado)
        console.log("punto venta", puntoDeVenta)
        console.log("id_funcion", idFuncion)

        let data = {
          numeroEmpleado,
          puntoDeVenta,
          idFuncion
        }
        if(data.puntoDeVenta.length == 0 )delete data.puntoDeVenta
        if(data.idFuncion.length == 0 )delete data.idFuncion
        if(data.numeroEmpleado.length == 0 )delete data.numeroEmpleado

        if(Object.entries(data).length == 0) {  
          this.ngxService.stop();
          return this.showAlert('Aviso', `Sin data en el archivo.`)
        }
        await this.validUsersFileX3(data);

        this.ngxService.stop() 

      },500)

    } catch (error) {
      console.log(error);
      this.ngxService.stop()
      return this.showAlert('Error al subir el archivo', `Lo sentimos, hubo un problema al subir archivo, favor de volver a intentar.`)
    }
  }

  async validUsersFileX3(objeto: any) {
    try {
      const encoded: any = await encrypt({ data: objeto });
      const result:any = await this.permisosAutomatizados.getEmployeesValidX3({ data: encoded.data})
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data

      if(response.code != 200) {
        return this.showAlert('Algo salió mal', `Error al validar la información.`) 
      }

      let employeeData = decoded.data.items[0] 
      let listArray = []
      let noValidos = []

      /* VALIDOS */
      employeeData.validos.forEach(person => {
        listArray.push({
          employee_name: person.employee_name,
          employee_number: person.employee_number,
          employee_data: `${person.employee_number} - ${person.employee_name}`
        })
      });

      /* INVALIDOS */
      if( employeeData.inValidos[0] ) {
        employeeData.inValidos.forEach(number => {
          noValidos.push( number.employee_number )
        });
      }
      this.onValidateEmployees = true
      this.allowedEmployees = listArray
      this.notAllowedEmployees = noValidos
      this.totalNumberExcel = listArray.length

      const dataEmployees: any = await this.filterByEmployeeNumber(employeeData.validos)
      this.employeesArrayList.emit(dataEmployees)

    } catch (error) {
      console.log('error')
      this.ngxService.stop();
      return this.showAlert('Algo salió mal', `Error al validar la información.`) 
    }
  }

  filterByEmployeeNumber(list: any): any {
    const newList: any = []

    for (const element of list) {
      newList.push(element.employee_number.toString())
    }
    return newList
  }

  async uploadFile(json: any) {
    let keys = Object.keys(json);
    const date = new Date();
    const formatDate = `${date.getFullYear()}/${date.getMonth()+1}/${date.getDate()}`

    if(keys.length >= 1){
      let dataEmployees = [];
      json.forEach(element => {
        if(element["NO_EMPLEADO"]){
          dataEmployees.push({
            employee_id: element["NO_EMPLEADO"],
            fecha_inicio: null,
            fecha_fin: null
          })
        }
      });

      //const text = `{data:{udn:${this.userData.idCliente},employees:${JSON.stringify(dataEmployees)}}}` 
      const text = `{"data": { "udn_id": "${this.userData.idCliente}", "employees": ${JSON.stringify(dataEmployees)} }}`;
      //const key = `red-unica/permisos-automatizados/${formatDate}/employees${date.getTime()}.json`
      const key = `ru-inasistencias/${formatDate}/employees${date.getTime()}.json`
      this.jsonData = `{"lista":{"empleados":${JSON.stringify(dataEmployees)}}}`
      const response = await upload(environment.AWS_CONFIG.bucket, key, text,'text/plain')
      return response
    }
    else {
      this.ngxService.stop()
      return this.showAlert('Algo salió mal', `El archivo no contiene ningún registro válido.`)
    } 
  }

  async validateEmployees(key: any) {
    try {
      let object = {
        data:{
          bucket: environment.AWS_CONFIG.bucket,
          file: key
        }
      }
      const encoded: any = await encrypt(object);
      const result:any = await this.permisosAutomatizados.validateEmpleadosOld({ data: encoded.data})
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data

      if(response.code === 200) {
        return response.items[0].uri_file
      }

      this.ngxService.stop();
    } catch (error) {
      console.log('error')
      this.ngxService.stop();
      return this.showAlert('Algo salió mal', `Error al validar la información.`) 
    }
  }

  validateExtension(extension: string) {
    extension = extension.toLowerCase();
    if (extension === FILE_EXTENSION.JPEG || extension === FILE_EXTENSION.JPG || extension === FILE_EXTENSION.PNG) {
      return 'image/*';
    }
    if (extension === FILE_EXTENSION.PDF) {
      return 'application/pdf';
    }
    if (extension === FILE_EXTENSION.MP3) {
      return 'audio/*';
    }
    if (extension === FILE_EXTENSION.XLSX || extension === FILE_EXTENSION.XLSM) {
      return 'application/vnd.ms-excel';
    }
    if (extension === FILE_EXTENSION.MP4) {
      return 'video/mp4';
    } else {
      return false;
    }
  }

  cleanFile() {
    this.onValidateEmployees = false
    this.allowedEmployees = []
    this.totalNumberExcel = 0
    this.notAllowedEmployees = 0
    this.fileInput.nativeElement.value = null;
    this.fileX3.nativeElement.value = null;
    this.employeesArrayList.emit([])
  }

  onChangeTable(ev: boolean) {
    this.showAllowedEmployees = ev
  }

}

